"use client";

import { AnalyticsProvider, identifyUser, resetUser } from "@onsand/analytics";
import { clubApi, getQueryClient } from "@onsand/api";
import { SessionProvider, useSession } from "@onsand/auth";
import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { SessionExpiryGuard } from "@/components/session-expiry-guard";

function PostHogIdentify() {
	const { session } = useSession();
	const prevUserId = useRef<string | null>(null);

	useEffect(() => {
		if (session?.user_id) {
			if (prevUserId.current !== session.user_id) {
				identifyUser(session.user_id, { role: session.role });
				prevUserId.current = session.user_id;
			}
		} else if (prevUserId.current) {
			resetUser();
			prevUserId.current = null;
		}
	}, [session]);

	return null;
}

export function Providers({ children }: { children: React.ReactNode }) {
	const queryClient = getQueryClient();

	return (
		<QueryClientProvider client={queryClient}>
			<SessionProvider queryFn={() => clubApi.session.me()}>
				<AnalyticsProvider>
					<PostHogIdentify />
					<SessionExpiryGuard />
					{children}
				</AnalyticsProvider>
			</SessionProvider>
		</QueryClientProvider>
	);
}
